import { render } from "./price.vue?vue&type=template&id=3c0af784&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import "./price.vue?vue&type=style&index=0&id=3c0af784&scoped=true&lang=css"
import "./price.vue?vue&type=style&index=1&id=3c0af784&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0af784"]])

export default __exports__